import UpgradeAccountEventReporter from './UpgradeAccountEventReporter';

export default UpgradeAccountEventReporter;
